import { Badge } from 'components/bgp-overview/Badge';
import React from 'react';
import { BadgeColor } from '../Badge/Badge';
import { BoxPanel } from '../BoxPanel';

interface PrefixCardProps {
  prefix: string;
  badgeColor: BadgeColor;
}

export const PrefixCard: React.FC<PrefixCardProps> = ({ prefix, badgeColor }: PrefixCardProps) => {
  return (
    <BoxPanel className="flex-none w-40 mt-5 items-center">
      <Badge badgeColor={badgeColor} />
      <div className="p-3 break-words">{prefix}</div>
    </BoxPanel>
  );
};
